import React, { Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getMyContacts } from '../../actions/contact';
import ContactBar from '../SideBars/Contact';
import { Button, makeStyles } from '@material-ui/core';

const AllContacts = ({ getMyContacts, contact: { contacts } }) => {
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
      marginTop: '1em'
    },
    contactButton: {
      display: 'block',
      marginBottom: '5px',
      textTransform: 'capitalize',
      background: '#EEEEEE'
    },
    link: {
      color: 'black',
      display: 'flex'
    },
    contactDiv: {
      width: '800px'
    },
    nameSection: {
      display: 'flex',
      width: '40%'
    },
    contactName: {
      paddingRight: '5px'
    },
    organization: {
      paddingTop: '2.5px',
      color: '#7F7F7F'
    },
    contactPhone: {
      width: '30%',
      textAlign: 'left'
    },
    contactEmail: {
      width: '30%',
      textAlign: 'right'
    }
  }));

  const classes = useStyles();
  useEffect(() => {
    getMyContacts();
  }, [getMyContacts]);
  return (
    <div className={classes.root}>
      <div>
        <ContactBar />
      </div>
      <div>
        <Fragment>
          {contacts && contacts.length > 0 && (
            <Fragment>
              <div className={classes.contactDiv}>
                {contacts.map(contact => (
                  <Button
                    key={contact._id}
                    className={classes.contactButton}
                    variant='outlined'
                    fullWidth
                  >
                    <Link
                      to={`/show_contact/${contact._id}`}
                      className={classes.link}
                    >
                      <div className={classes.nameSection}>
                        <p className={classes.contactName}>
                          {contact.firstName} {contact.lastName}
                        </p>
                        <small className={classes.organization}>
                          {contact.organization}
                        </small>
                      </div>
                      <div></div>
                      <div className={classes.contactPhone}>
                        {contact.phone}
                      </div>
                      <div className={classes.contactEmail}>
                        {contact.email}
                      </div>
                    </Link>
                  </Button>
                ))}
              </div>
            </Fragment>
          )}
        </Fragment>
      </div>
    </div>
  );
};

AllContacts.propTypes = {
  getMyContacts: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  contact: state.contact
});

export default connect(mapStateToProps, { getMyContacts })(AllContacts);



// WEBPACK FOOTER //
// ./src/components/contact/AllContacts.js